const namespace = "BOTTOMSHEET_";

const CONSTANTS = {
  BOTTOMSHEET_SHARE_CONTENT_VIA: `${namespace}SHARE_CONTENT_VIA`,
  BOTTOMSHEET_ABOUT_THIS_COURSE: `${namespace}ABOUT_THIS_COURSE`,
  BOTTOMSHEET_VIDEO_RESTRICTIONS: `${namespace}VIDEO_RESTRICTIONS`,
  BOTTOMSHEET_UPCOMING_LIVE_CLASSES: `${namespace}UPCOMING_LIVE_CLASSES`,
  BOTTOMSHEET_APPLY_COUPON: `${namespace}APPLY_COUPON`,
  BOTTOMSHEET_APPLY_BUNDLE: `${namespace}APPLY_BUNDLE`,
  BOTTOMSHEET_APPLY_BUNDLE_RECEIPT: `${namespace}APPLY_BUNDLE_RECEIPT`,
  BOTTOMSHEET_CONTENT_LOCKED: `${namespace}CONTENT_LOCKED`,
  BOTTOMSHEET_WHAT_ARE_YOU_WATCHING: `${namespace}WHAT_ARE_YOU_WATCHING`,
  BOTTOMSHEET_TEST_IS_LOCKED: `${namespace}TEST_IS_LOCKED`,
  BOTTOMSHEET_SELECT_STATE: `${namespace}SELECT_STATE`,
  BOTTOMSHEET_SELECT_DYNAMIC_BUNDLING: `${namespace}SELECT_DYNAMIC_BUNDLING`,
  BOTTOMSHEET_SELECT_ADDRESS: `${namespace}SELECT_ADDRESS`,
  POPUP_DELETE_ADDRESS: `${namespace}DELETE_ADDRESS`,
  BOTTOMSHEET_CHECKOUT_OPTIONS: `${namespace}BOTTOMSHEET_CHECKOUT_OPTIONS`,

  BOTTOMSHEET_RUNNING_TIGHT_ON_BUDGET: `${namespace}RUNNING_TIGHT_ON_BUDGET`,
  BOTTOMSHEET_CONGRATULATIONS: `${namespace}CONGRATULATIONS`,
  BOTTOMSHEET_DUE_DATE: `${namespace}DUE_DATE`,
  BOTTOMSHEET_COURSE_LOCKED: `${namespace}COURSE_LOCKED`,
  BOTTOMSHEET_PAYMENT_FAILED: `${namespace}PAYMENT_FAILED`,
  BOTTOMSHEET_FREE_TRIAL_OPEN_VIA_TAB_SWITCH: `${namespace}FREE_TRIAL_OPEN_VIA_TAB_SWITCH`,
  BOTTOMSHEET_FREE_TRAIL: `${namespace}FREE_TRAIL`,
  BOTTOMSHEET_ENROLL_FOR_FREE_COURSE: `${namespace}ENROLL_FOR_FREE_COURSE`,
  BOTTOMSHEET_LOCKED_FREE_COURSE: `${namespace}LOCKED_FREE_COURSE`,
  BOTTOMSHEET_COURSE_FACULTY_LIST: `${namespace}BOTTOMSHEET_COURSE_FACULTY_LIST`,
  DYNAMIC_BUNDLING_POPUP: `${namespace}DYNAMIC_BUNDLING_POPUP`,

  BOTTOMSHEET_VIEWS_EXHAUSTED: `${namespace}VIEWS_EXHAUSTED`,
  BOTTOMSHEET_VIEW_COURSE_ACCESS_REMOVED: `${namespace}BOTTOMSHEET_VIEW_COURSE_ACCESS_REMOVED`,
  BOTTOMSHEET_DOWNLOAD_VIDEO: `${namespace}DOWNLOAD_VIDEO`,
  BOTTOMSHEET_EXPIRY_SOON: `${namespace}EXPIRY_SOON`,
  BOTTOMSHEET_PAYMENT_PROCESSING: `${namespace}PAYMENT_PROCESSING`,

  BOTTOMSHEET_TEST_IS_TEMPORARILY_LOCKED: `${namespace}TEST_IS_TEMPORARILY_LOCKED`,
  BOTTOMSHEET_TEST_IS_TEMPORARILY_LOCKED_TIMING: `${namespace}TEST_IS_TEMPORARILY_LOCKED_TIMING`,
  BOTTOMSHEET_ANNOUNCEMENTS_ATTACHMENTS: `${namespace}ANNOUNCEMENTS_ATTACHMENTS`,

  BOTTOMSHEET_PAYMENT_METHODS_MODAL: `${namespace}PAYMENT_METHODS_MODAL`,
  BOTTOMSHEET_MULTI_PAYMENT_METHOD_MODAL: `${namespace}MULTI_PAYMENT_METHOD_MODAL`,
  BOTTOMSHEET_PAYMENT_METHODS_SET: `${namespace}PAYMENT_METHODS_SET`,
  BOTTOMSHEET_PAYMENT_METHODS_SELECT: `${namespace}PAYMENT_METHODS_SELECT`,
  BOTTOMSHEET_MULTI_PAYMENT_METHODS_SELECT: `${namespace}MULTI_PAYMENT_METHODS_SELECT`,

  BOTTOMSHEET_IS_SHOW_TIGHT_ON_BUDGET: `${namespace}IS_SHOW_TIGHT_ON_BUDGET`,

  CLOSE_ALL_BOTTOMSHEET: `CLOSE_ALL_${namespace}`,
  SHOW_FULLSCREEN_LOADER: `SHOW_FULLSCREEN_LOADER`,
  SHOW_PAYMENT_LOADER: `SHOW_PAYMENT_LOADER`,

  POPUP_REMOVE_SUGGESTIONS: `${namespace}REMOVE_SUGGESTIONS`,
  SHOW_POPUP_PAYMENT_PROCESSING: `${namespace}_SHOW_POPUP_PAYMENT_PROCESSING`,
  SET_SOCIAL_LINKS_DATA : `${namespace}SET_SOCIAL_LINKS_DATA`,

  SET_SHOW_NOT_SUPPORTED_BOTTOMSHEET : `${namespace}SET_SHOW_NOT_SUPPORTED_BOTTOMSHEET`,
  TOGGLE_VIDEO_BOTTOM_SHEET : `${namespace}TOGGLE_VIDEO_BOTTOM_SHEET`,
  IDFYS_LOCK_CONTENT : `${namespace}IDFYS_LOCK_CONTENT`,
  IS_PAYMENT_REJECTED: `${namespace}IS_PAYMENT_REJECTED`,
  SET_SHOW_INTRO_VIDEO_BOTTOM_SHEET: `${namespace}SET_SHOW_INTRO_VIDEO_BOTTOM_SHEET`
};

export default CONSTANTS;
